module.exports = __webpack_public_path__ + "img/plus_btn.ad9d1efe.svg";